import { Auth0Provider } from '@auth0/auth0-react'
import * as Rollbar from '@rollbar/react'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactModal from 'react-modal'
import { Provider } from 'react-redux'
import { utils } from '@ims/1edtech-frontend-common'
import { ThemeProvider } from 'styled-components'

import 'lib/styles/css/print.css'
import 'lib/styles/css/modals.css'
import 'lib/styles/css/index.css'
//import initializeErrorTracking from 'lib/errorTracking'
import { setupEventTracking } from 'lib/eventTracking'
import { hideFreshDeskWidget } from 'lib/freshdesk'
import store from 'lib/store'
import theme from 'lib/styles/theme'
import 'domains/commonCartridge/styles/ccReport.css'
import { OAUTH_REDIRECT_ROUTE } from 'domains/application/navigation/routes'
import StartupScreen from 'domains/application/screens/StartupScreen'

const rollbarConfig = {
  accessToken: utils.env.getEnvVariable(
    'ROLLBAR_ACCESS_TOKEN',
    process.env.ROLLBAR_ACCESS_TOKEN,
  ),
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: utils.host.getHostname(),
  disabled: utils.host.getHostname() === 'localhost',
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
}

//initializeErrorTracking()
setupEventTracking()
hideFreshDeskWidget()
ReactModal.setAppElement('#modals')

ReactDOM.render(
  <Rollbar.Provider config={rollbarConfig}>
    <Auth0Provider
      domain={utils.env.getEnvVariable(
        'AUTH0_DOMAIN',
        process.env.AUTH0_DOMAIN,
      )}
      clientId={utils.env.getEnvVariable(
        'AUTH0_CLIENT_ID',
        process.env.AUTH0_CLIENT_ID,
      )}
      authorizationParams={{
        redirect_uri: `${window.location.origin}${OAUTH_REDIRECT_ROUTE}`,
        audience: `${utils.env.getEnvVariable(
          'AUTH0_AUDIENCE',
          process.env.AUTH0_AUDIENCE,
        )}`,
      }}
      cacheLocation="localstorage"
    >
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <StartupScreen />
        </ThemeProvider>
      </Provider>
    </Auth0Provider>
  </Rollbar.Provider>,
  document.getElementById('root'),
)
